import React from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';

export default class BoardController extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      drawOfferSent: false
    }
    this.offerDraw = () => {
      this.props.endGame("DRAW OFFERED");
      this.setState({
        drawOfferSent: true
      });
    }
    this.cancelDraw = () => {
      this.props.endGame("DRAW CANCELLED");
      this.setState({
        drawOfferSent: false
      });
    }
  }

  render() {
    const { history } = this.props;
    const sortedHistory = _.chunk(history, 2);

    return (
      <div className={this.props.controller}>
        <div className="pgn-list">
          {sortedHistory.map((fullMove, i) => {
            return <p className="full-move" key={i}>
              <span className="move-number">{i + 1}.</span>
              <span className="pgn-item">{fullMove[0]}</span>
              <span className="pgn-item">{fullMove[1]}</span>
            </p>
          })}
        </div>
        <div className="controller-bottom">
          <div className="status">
            <span>{this.props.statusText}</span>
          </div>
          <div className="navigate-history">
            <button className="nav-button">PREV</button>
            <button className="nav-button">NEXT</button>
          </div>
          {!this.props.gameOverStatus &&
            <div className="game-options">
              {history.length < 2
                ? <button className="end-button" onClick={() => this.props.endGame("ABORT")}>ABORT</button>
                : !this.props.showAcceptDraw && !this.state.drawOfferSent
                  ? <button className="end-button" onClick={() => this.offerDraw()}>OFFER DRAW</button>
                  : this.state.drawOfferSent
                    ? <button className="end-button" onClick={() => this.cancelDraw()}>CANCEL DRAW</button>
                    : this.props.showAcceptDraw
                      ? <>
                          <button className="end-button" onClick={() => this.cancelDraw()}>CANCEL DRAW</button>
                          <button className="end-button" onClick={() => this.props.endGame("DRAW ACCEPTED")}>ACCEPT DRAW</button>
                        </>
                      : null
              }
              <button className="end-button" onClick={() => this.props.endGame("RESIGN")}>RESIGN</button>
            </div>
          }
          {(this.props.gameOver || this.props.gameOverStatus) &&
            <div className="game-over-options">
              <button className="game-over-button">ANALYZE</button>
              <Link to={"/lobby"}>
                <button className="game-over-button">RETURN TO LOBBY</button>
              </Link>
            </div>
          }
        </div>
      </div>
    ); 
  } 
}